const WishListButton = require('./wish_list_button');

const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

class WishListButtonLoader {
  constructor() {
    this._buttons = {};
  }

  load(context = document) {
    let elements = context.querySelectorAll('[data-add-favorite-button]');
    elements = Array.prototype.filter.call(elements, function(el) {
      return !el.getAttribute('data-favorite-toggler-loaded');
    });

    if (elements.length === 0) {
      return;
    }

    /* For signed out user just redirect to login form */
    if (this._checkUserSignin() === false) {
      const signinUrl = elements[0].getAttribute('data-path-signin');
      Array.prototype.forEach.call(elements, el => {
        let link = el.querySelector('a');
        if (link) {
          link.setAttribute('href', signinUrl);
        }
      });
      return;
    }

    let url = elements[0].getAttribute('data-path-load');

    Array.prototype.forEach.call(elements, el => {
      const button = new WishListButton(el);
      this._buttons[button.id] = button;
    });

    this._enableFavoritedButtons(url, id => {
      if (this._buttons.hasOwnProperty(id)) {
        let button = this._buttons[id];
        button.setActive();
        button.setLoaded();
      }
    });
  }

  _checkUserSignin() {
    return document.querySelector('html').classList.contains('signed-in');
  }

  _enableFavoritedButtons(url, callback) {
    let request = new XMLHttpRequest();
    request.open('GET', url, true);
    request.setRequestHeader(
      'X-CSRF-Token',
      document.querySelector('meta[name="csrf-token"]').content
    );
    request.responseType = 'json';

    request.onload = function() {
      if (request.status >= 200 && request.status < 400) {
        let res = request.response;

        if (!res.wish_list_items && !isIE11) {
          /*
            I dont know why IE11 is throwing even though:
              this condition is not met
              JSON response is correct
              in ie dev console it passes every test

            but this throw is stopping execution and feature doesnt work at all

            https://sentry.io/platform-os/volte-production/issues/446993174/
          */
          throw new Error('Invalid response from wish list buttons fetch');
        }

        res.wish_list_items.map(item => item.wishlistable_id).forEach(callback);
      } else {
        throw new Error(
          `Unable to parse wish list buttons response. ${JSON.stringify(
            request
          )}`
        );
      }
    };

    request.onerror = function() {
      throw new Error('Unable to reach server to fetch wish list status');
    };

    request.send();
  }
}

module.exports = new WishListButtonLoader();



// WEBPACK FOOTER //
// ./src/javascripts/platform/components/wish_list_buttons/wish_list_button_loader.js